
import { JsonObject, JsonProperty } from 'json2typescript';
import { City } from './city';

@JsonObject('Court')
export class Court {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('name', String, true)
    name = '';

    @JsonProperty('name_ar', String, true)
    nameAr = '';

    @JsonProperty('address', String, true)
    address = null;

    @JsonProperty('city_id', Number, true)
    cityId = undefined;

    @JsonProperty('city', City, true)
    city = null;

    @JsonProperty('phone', String, true)
    phone = null;

    @JsonProperty('fax', String, true)
    fax = null;

    @JsonProperty('order_id', Number, true)
    order = null;

    @JsonProperty('created_date', String, true)
    createdDate = null;

    @JsonProperty('updated_date', String, true)
    updatedDate = null;

    @JsonProperty('is_deleted', Boolean, true)
    isDeleted = false;

    get getName() {
        return this.nameAr || this.name;
    }

    get location(): string {
        let l = "";
        l = this.address ? this.address + ", " : "";
        l += this.city ? this.city.getName : "";
        return (this.address || this.city.getName) ? l : '—';
    }
}